export default __webpack_public_path__ + "static/media/icon-4-green-round.82431367.svg";